export const getScrollbarWidth = () => {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.width = '50px';
    scrollDiv.style.height = '50px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
};

interface ElementIE extends Element {
    msMatchesSelector?: Element['matches'];
}

export const matches = (element: Element, selector: string): boolean => {
    const elementIE = element as ElementIE;
    if (elementIE.msMatchesSelector) {
        return elementIE.msMatchesSelector(selector);
    }
    return element.matches(selector);
};

export const closestAncestor = (element: Element, selector: string): Element | null => {
    if (element.closest) {
        return element.closest(selector);
    }
    let elementToSearch: Element | null = element;
    do {
        if (matches(elementToSearch, selector)) {
            return elementToSearch;
        }
        elementToSearch = elementToSearch.parentElement || (elementToSearch.parentNode as Element);
    } while (elementToSearch != null && elementToSearch.nodeType === Node.ELEMENT_NODE);
    return null;
};

export const focus = (element: HTMLElement | null) => {
    if (element) {
        element.scrollIntoView(false);
        element.focus();
    }
};
